import type { ReactElement, ReactNode } from "react"
import { useState } from "react"
import Formily from "@gatsby-plugin-generic-page/components/Formily/Formily"
import type { Formily as FormilyType } from "@gatsby-plugin-generic-page/fragments/formily"
import { SquidexFormType } from "@gatsby-plugin-generic-page/types/formType"
import { typeMatches } from "@onestore-graphql"
import isEmpty from "~/lib/isEmpty"
import type { Forms } from "~/types/squidex"
import ModalTemplateWrapper from "../ModalTemplateWrapper"

export interface FormModalProps {
  form: Forms[]
  headingText?: ReactNode
  onCloseButtonClick?: { (): void }
}

export default function FormModal({
  form,
  onCloseButtonClick,
}: FormModalProps): ReactElement<FormModalProps> | null {
  const [modalOpen, setModalOpen] = useState(true)

  if (
    !isEmpty(form) &&
    typeMatches(form[0].__typename, SquidexFormType.FORMILY_FORM)
  ) {
    const { flatData } = form[0] as FormilyType

    return (
      <ModalTemplateWrapper
        onCloseButtonClick={onCloseButtonClick}
        width="narrow"
        isOpen={modalOpen}
        title={flatData.title}
        content={
          <Formily
            captchaEnabled={flatData.captcha}
            button={flatData.formButton}
            onSubmitSuccess={() =>
              setTimeout(() => {
                setModalOpen(false)
              }, 1000)
            }
            schema={flatData.schema}
            target={flatData.target}
            formId={flatData.formId}
          />
        }
      />
    )
  }

  return null
}
